var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRivalFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.67 62.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #25282d;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        stroke: #9a0df9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.76,
    y: 1,
    width: 9.4,
    height: 48.88,
    rx: 2.51,
    ry: 2.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.16,21.68h3.38c2.29,0,4.14,1.85,4.14,4.14v1.11c0,2.29-1.85,4.14-4.14,4.14h-3.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.74,47.38c-2.41-2.03-14.12-10.84-35.7-10.84v-20.51c20.99,0,31.63-7.71,34.98-10.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.04,16.04h-4.7c-5.71,0-10.34,4.63-10.34,10.34h0c0,5.71,4.63,10.34,10.34,10.34h4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.38,36.72l5.19,21.49c.42,1.73,1.97,2.95,3.74,2.95h0c2.49,0,4.33-2.33,3.75-4.75l-2.49-10.36c-.83-3.45,2.2-8.03,6.06-8.03"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRivalFeedbackIcon);
export default __webpack_public_path__ + "static/media/rival-feedback-icon.9428f0126ab21d7a857d331591ff94fa.svg";
export { ForwardRef as ReactComponent };